module.exports = __webpack_public_path__ + "img/Approvals.c4f2027e.png";